module.exports = __webpack_public_path__ + "img/img_web_01_feature1.7ea6f72e.png";